/* eslint-disable */
// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { container } from "../../../../api/Api";

export const getAllContainer = createAsyncThunk(
  "appContainer/getAllContainer",
  async (query) => {
    try {
      return container.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getContainerForFilter = createAsyncThunk(
  "appContainer/getContainer",
  async () => {
    try {
      return container.getAllContainer();
    } catch (error) {
      console.error(error);
    }
  }
);

export const containerActive = createAsyncThunk(
  "appContainer/containerActive",
  async (value) => {
    return container.active(value);
  }
);

export const addContainer = createAsyncThunk(
  "appContainer/addContainer",
  async (values) => {
    try {
      return container.create(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const editContainer = createAsyncThunk(
  "appContainer/editContainer",
  async (values) => {
    try {
      return container.editContainer(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteContainer = createAsyncThunk(
  "appContainer/deleteContainer",
  async (id) => {
    return container.remove(id);
  }
);

export const appContainerSlice = createSlice({
  name: "appContainer",
  initialState: {
    container: [],
    containerForFilter: [],
    containerFetch: false,
    containerForFilterFetch: false,
    metaData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllContainer.fulfilled, (state, action) => {
        state.metaData = action.payload.data.metaData;
        state.container = action.payload?.data?.data;
        state.containerFetch = true;
      })
      .addCase(getContainerForFilter.fulfilled, (state, action) => {
        state.containerForFilter = action.payload?.data?.data;
        state.containerForFilterFetch = true;
      })
      .addCase(deleteContainer.fulfilled, (state, action) => {
        state.containerFetch = false;
        state.containerForFilterFetch = false;
      })
      .addCase(containerActive.fulfilled, (state, action) => {
        state.containerFetch = false;
        state.containerForFilterFetch = false;
      })
      .addCase(addContainer.fulfilled, (state, action) => {
        state.containerFetch = false;
        state.containerForFilterFetch = false;
      });
  },
});

export default appContainerSlice.reducer;
